<!--Empty content placeholder-->
<div *ngIf="transfers?.length === 0 && !loading">
  <p class="transfers-empty">Keine Transfers verfügbar</p>
</div>
<div class="transfer-list" *ngIf="!loading">
  <!--Transfer Container-->
  <ng-container *ngFor="let transfer of transfers, let i = index">
    <div class="transfer-container {{colorScheme.main}}">
      <!--Player Image-->
      <div class="player-image-container">
        <lib-lazy-image [picture]="transfer.player_info.pictures[0]"
                        [targetRes]="imageRes"
                        [alt]="transfer.player_info.playername"
                        class="player-image"></lib-lazy-image>
      </div>
      <!--Name container-->
      <div class="name-container">
        <ng-container *ngIf="transfer.player_info.playername; else fullName">
          <span class="player-name">{{ transfer.player_info.playername }}</span>
        </ng-container>
        <ng-template #fullName>
                     <span>
                     <span class="first-name {{colorScheme.main}}">{{ transfer.player_info.firstname }} </span> <span class="player-name">{{ transfer.player_info.lastname }}</span>
                     </span>
        </ng-template>
      </div>
      <!--Team container-->
      <div class="team-container-wrapper">
        <ng-container *ngIf="getTeamName(transfer.from_team); else showSpacer">
          <!--From team container-->
          <a *ngIf="transfer.from_team.readable_id; else noLink" [href]="getLink(transfer.from_team.readable_id)" class="team-container">
            <span class="from-team-name">{{ getTeamName(transfer.from_team) }}</span>
            <lib-lazy-image [picture]="getLogoPicture(transfer.from_team)"
                            [targetRes]="imageRes"
                            [class.has-link]="transfer.from_team.readable_id"
                            class="team-image">
            </lib-lazy-image>
          </a>
          <ng-template #noLink>
            <div class="team-container">
              <span class="from-team-name">{{ getTeamName(transfer.from_team) }}</span>
              <lib-lazy-image [picture]="getLogoPicture(transfer.from_team)" [targetRes]="imageRes" class="team-image"></lib-lazy-image>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #showSpacer>
          <span class="team-spacer"></span>
        </ng-template>
        <mat-icon>arrow_forward</mat-icon>
        <!--To team container-->
        <a *ngIf="transfer.to_team.readable_id; else noLink" [href]="getLink(transfer.to_team.readable_id)" class="team-container">
          <lib-lazy-image [picture]="getLogoPicture(transfer.to_team)"
                          [targetRes]="imageRes"
                          [class.has-link]="transfer.to_team.readable_id"
                          class="team-image">
          </lib-lazy-image>
          <span class="to-team-name">{{ getTeamName(transfer.to_team) }}</span>
        </a>
        <ng-template #noLink>
          <div class="team-container">
            <lib-lazy-image [picture]="getLogoPicture(transfer.to_team)" [targetRes]="imageRes" class="team-image"></lib-lazy-image>
            <span class="to-team-name">{{ getTeamName(transfer.to_team) }}</span>
          </div>
        </ng-template>
      </div>
      <!--Season info container-->
      <div *ngIf="getSeasonInfo(transfer)" class="season-info-container">
        <span>{{ getSeasonInfo(transfer)}}</span>
      </div>
    </div>
    <!--Ad container-->
    <ng-container *ngIf="((i + 1) % 6 === 0)">
      <lib-ad class="mb-1"></lib-ad>
    </ng-container>
  </ng-container>
</div>
<button mat-raised-button class="news-load-more" *ngIf="moreTransfersAvailable && !loading" (click)="loadMoreTransfers()">
  Weitere Transfers laden
</button>
